// extracted by mini-css-extract-plugin
var _1 = "Activity_author__ywzTH";
var _2 = "Activity_board__88uxy";
var _3 = "Activity_content__1-pYF";
var _4 = "Activity_contentText__mQxst";
var _5 = "Activity_date__mS8ym";
var _6 = "Activity_project__oewYL";
var _7 = "Activity_user__yfGwg";
var _8 = "Activity_wrapper__I89PJ";
export { _1 as "author", _2 as "board", _3 as "content", _4 as "contentText", _5 as "date", _6 as "project", _7 as "user", _8 as "wrapper" }
